module.exports = __webpack_public_path__ + "media/components/assets/legend_social_step_5-db3cc22e51bc28ab9094bff7ef45f0fd.svg";